import React from 'react';
import { useRecoilValue } from 'recoil';
import useCartActions from 'app-state/cart-actions';
import { cartState } from 'app-state/cart-state';
import { Product } from 'utils/Product';
import { IconButton } from './Icon';
import { alertCircleIcon, minusCircleIcon, plusCircleIcon } from 'assets/icons';

const CartQuantityModifer = ({ product }: { product: Product }) => {
  const { cartContents } = useRecoilValue(cartState);
  const { changeCartQuantity, addCartProduct } = useCartActions();
  const atMaxStock = cartContents[product.id] && (cartContents[product.id].cartQuantity === product.quantity);

  return <div
    data-locator='cart-quantity-modifier'
    className={`flex place-items-center text-sm ${product.quantity === 0 ? 'hidden' : ''}`} >
    {cartContents[product.id] && cartContents[product.id].cartQuantity > 0 && <>
      <IconButton
        data-locator='remove-from-cart-button'
        label={`Remove one ${product.title} from cart`}
        onClick={() => changeCartQuantity({ id: product.id, modQuantity: -1 })}
        src={minusCircleIcon}
        alt='-'
        title={`Remove one ${product.title} from cart`} />
      <span data-locator='item-quantity' aria-label={`${product.title} cart quantity`} className='mx-2 w-3/4'>
        {cartContents[product.id].cartQuantity}
      </span>
    </>}
    <IconButton
      data-locator='add-to-cart-button'
      label={`Add one ${product.title} to cart`}
      disabled={atMaxStock}
      title={atMaxStock ? `${product.title} is at it's maximum order limit` : `Add one ${product.title} to cart`}
      onClick={() => addCartProduct(product)}
      src={atMaxStock ? alertCircleIcon : plusCircleIcon}
      alt='+' />
  </div>;
};

export default CartQuantityModifer;
